import React from 'react';
import { observer } from 'mobx-react';
// locals
import Loading from './Loading';
import DisplayError from './DisplayError';
export default observer(function BaseChordDisplay(_ref) {
  var display = _ref.display;
  if (display.error) {
    return React.createElement(DisplayError, {
      model: display
    });
  }
  if (!display.filled) {
    return React.createElement(Loading, {
      model: display
    });
  }
  return display.reactElement;
});